<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/tournaments"></ion-back-button>
        </ion-buttons>
        <ion-item lines="none" color="none">
            @if (isLoading) {
                <ion-spinner name="dots"></ion-spinner>
            }
            <ion-label class="ion-text-wrap">{{ tournament?.name }}</ion-label>
        </ion-item>

        @if (!isLoading) {
            <ion-buttons slot="end">
                @if (!authService.authUserSignal()) {
                    <app-login-modal></app-login-modal>
                }

                <app-share-match [tournamentId]="tournament?._id" [position]="'header'"></app-share-match>
                @if (authService.authUserSignal()) {
                    <ion-button (click)="changeFollow()">
                        @if (!canFollow) {
                            <ion-icon slot="icon-only" name="notifications"></ion-icon>
                        } @else {
                            <ion-icon slot="icon-only" name="notifications-outline"></ion-icon>
                        }
                    </ion-button>
                }

                @if (isOwner || isTracker) {
                    <ion-button id="tournamentMenu" (click)="openTournamentMenu($event)">
                        <ion-icon slot="icon-only" name="settings-outline"></ion-icon>
                    </ion-button>
                }

            </ion-buttons>
        }

    </ion-toolbar>

    @if (showHeaderToolbar()) {
        <ion-toolbar>
            <ion-row class="content-width">                
                @if (showDays()) {
                    <ion-col>
                        <ion-item class="content-width" lines="none">
                            <ion-select [value]="selectedDay" interface="popover" placeholder="Select date" (ionChange)="changeTournamentDate($event)">
                                @for (date of tournamentDays; track $index) {
                                    <ion-select-option [value]="date">{{ date | date: 'longDate' }}</ion-select-option>
                                }
                            </ion-select>
                        </ion-item>
                    </ion-col>
                }

                @if (showVenues()) {
                    <ion-col>
                        <ion-item class="content-width" lines="none">
                            <ion-select value="all" interface="popover" placeholder="Select venue" (ionChange)="changeTournamentVenue($event)">
                                <ion-select-option value="all">{{ 'All venues' | translate }}</ion-select-option>
                                @for (venue of tournamentVenues; track $index) {
                                    <ion-select-option [value]="venue?.venueId">{{ venue?.venueName }}</ion-select-option>
                                }
                            </ion-select>
                        </ion-item>
                    </ion-col>
                }

            </ion-row>
        </ion-toolbar>
    }

    @if (isLiveScoreRoute() && tournament?.announcement?.message) {
        <ion-toolbar class="announcement-toolbar">
            <div class="announcement-content">
                <div class="announcement-message">
                    <ion-icon name="megaphone-outline" color="primary"></ion-icon>
                    
                    @if (!isEditingAnnouncement && (isOwner || isTracker)) {
                        <span class="editable-label" (click)="startEditingAnnouncement()">
                            {{ tournament.announcement.message }}
                            <ion-icon name="create-outline" class="edit-icon"></ion-icon>
                        </span>
                    } @else if (!isEditingAnnouncement) {
                        <span>{{ tournament.announcement.message }}</span>
                    } @else {
                        <ion-input 
                            [(ngModel)]="editingAnnouncementMessage"
                            [placeholder]="'Enter announcement message' | translate"
                            class="announcement-input">
                        </ion-input>
                        <ion-button fill="clear" size="small" (click)="saveAnnouncementMessage()" [disabled]="isSavingAnnouncement">
                            @if (isSavingAnnouncement) {
                                <ion-spinner name="crescent"></ion-spinner>
                            } @else {
                                <ion-icon name="checkmark" color="success"></ion-icon>
                            }
                        </ion-button>
                        <ion-button fill="clear" size="small" (click)="cancelEditingAnnouncement()">
                            <ion-icon name="close" color="danger"></ion-icon>
                        </ion-button>
                    }
                </div>
                
                @if (isOwner || isTracker) {
                    <div class="announcement-toggle">
                        <ion-toggle 
                            [checked]="tournament.announcement?.enabled"
                            (ionChange)="toggleAnnouncement($event)">
                        </ion-toggle>
                    </div>
                }
            </div>
        </ion-toolbar>
    }

</ion-header>